import { RuleDesignerSurface } from '@decisions/server/DecisionsFramework/Design/Flow/Service';
import { createContext } from 'react';

export interface IRuleDesignerContext {
  isDebug: boolean;
  isSampling: boolean;
  designerSurface: RuleDesignerSurface;
  isLargeRule?: boolean;
}

/**
 * When RuleDesigner will be moved to React context will be used there,
 * currently it wraps content of TruthTable, ExternalTruthTable, RuleTable components.
 */
export const RuleDesignerContext = createContext<IRuleDesignerContext>({
  isDebug: false,
  isSampling: false,
  designerSurface: RuleDesignerSurface.TruthTable,
  isLargeRule: false,
});
